import * as Api from '@/helpers/restApi'
import { unwrapFormEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  state: {
    NewsEducationDataTable: []
  },
  getters: {
    getNewsEducationDataTable: state => state.NewsEducationDataTable
  },
  mutations: {
  },
  actions: {
    setNewsEducationDataTable ({ state, dispatch }) {
      // ПОЛУЧАЕМ ОБЪЕКТ ДЛЯ таблицы со страницы новостей
      Api.getApi({
        url: '/api/Article/GetArticles'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            state.NewsEducationDataTable = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },

    setStatusNewsEducationTable ({ dispatch }, obj) {
      // публикуем и снимаем с публикации прямо из таблицы
      Api.putApi({
        url: `/api/Article/SetStatuses/${obj.Id}`,
        payload: obj
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsEducationDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setNewsFormEducation ({ commit, dispatch }, id) {
      // получаем объект тела новости для редактир или созд новой
      Api.getApi({
        url: `/api/Article/GetForm/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetFormData', data.Data)
            console.log('data.Data: ', data.Data)
            // глубокое копирование оригинального объекта
            commit('SetOriginFormData', data.Data)
            commit('SetShowSelectedTags', data.Data.InnerTags)
            commit('SetShowSelectedKeywords', data.Data.SearchTags)
            dispatch('setClearCacheInnerTagEducation')
            dispatch('setClearCacheInnerKeywordsEducation')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveNewsEducation ({ commit, dispatch }, form) {
      const payload = unwrapFormEditorHtml(form)
      return Api.putApi({
        url: `/api/Article/PutForm/${form.Id}`,
        payload
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            if (payload.DefferedDate !== null) {
              dispatch('setDefferedDateEducation', { Value: payload.DefferedDate, Id: data.Data.Value })
            }
            // сохраняет новый id в форму
            commit('SetFormDataId', data.Data.Value)
            // заново запрашивает форму с новым id версии
            dispatch('setNewsFormEducation', data.Data.Value)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateNewsEducation ({ commit, dispatch }, form) {
      // отправляем на сервер объект отредактированной новости
      return Api.putApi({
        url: '/api/Article/UpdateArticle',
        payload: form
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            // если выставлялась отложенная публ то отправка запроса на неё
            if (form.DefferedDate !== null) {
              dispatch('setDefferedDateEducation', { Value: form.DefferedDate, Id: form.Id })
            }
            // сохраняет новый id в форму
            // commit('SetFormDataId', form.Id)
            // заново запрашивает измененную форму
            dispatch('setNewsFormEducation', form.Id)

            // включаем и отключаем прелоадер
            commit('SetBigPreloader', true)
            setTimeout(() => {
              commit('SetBigPreloader', false)
            }, 1000)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteNewsEducation ({ dispatch }, id) {
      // удаление новости из таблицы
      Api.deleteApi({
        url: `/api/Article/Delete/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsEducationDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCloneNewsEducation ({ dispatch }, id) {
      // клонирование новости из таблицы
      Api.getApi({
        url: `/api/Article/CloneArticle/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsEducationDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setToggleNewsEducationPublish ({ getters, dispatch }, val) {
      // снятие с публикации и опубликование из страницы
      // редактора
      Api.putApi({
        url: `/api/Article/TogglePublish/${getters.getFormData.Id}`,
        payload: { Value: val }
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDefferedDateEducation ({ dispatch }, obj) {
      console.log('obj: ', obj)
      // Для установления отложенной даты публикации
      Api.putApi({
        url: `/api/Article/SetDefferedDate/${obj.Id}`,
        payload: { Value: obj.Value }
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            // state.FormData.Id = data.Data.Value
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
